<h2 mat-dialog-title>Send Email to (unplayed) Opponents</h2>

<mat-dialog-content>
   <form *ngIf="!busy" [formGroup]="form">
      What days are you available to play?
      <br />
      <div formArrayName="days">
         <div *ngFor="let checkbox of days.controls; let i = index">
            <input type="checkbox" [formControlName]="i" id="checkbox-day-{{i}}" style="margin-right: 3px;">
            <label for="checkbox-day-{{i}}">{{strDaysLong[i]}}</label>
         </div>
      </div>
      What times are you available to play?
      <br />
      <div formArrayName="times">
         <div *ngFor="let checkbox of times.controls; let i = index">
            <input type="checkbox" [formControlName]="i" id="checkbox-time-{{i}}" style="margin-right: 3px;">
            <label for="checkbox-time-{{i}}">{{strTimesLong[i]}}</label>
         </div>
      </div>
      What is your preferred contact method?
      <br />
      <select formControlName="preferredContact">
         <option value="">-- Select --</option>
         <option value="Text">Text</option>
         <option value="Email">Email</option>
         <option value="Call">Phone Call</option>
      </select>
   </form>
</mat-dialog-content>

<mat-dialog-actions style="float: right;">
   <a href="#" (click)="cancel($event)">Cancel</a>
   &nbsp;&nbsp;
   <button class="btn btn-primary" (click)="save()" [disabled]="!form || form.invalid">Send Email</button>
</mat-dialog-actions>